// Centralized portfolio content
// This file contains all the text content used across the portfolio
// Update content here to reflect changes everywhere

export const portfolioContent = {
  about: {
    title: 'Paul Walker - Backend Developer',
    subtitle: 'Get to know me',
    content: `Hello! My name is Paul Walker, though you can call me Trey. I'm deeply
engrossed in the world of Backend Engineering, where I've contributed
to compelling projects like Kubby Buddy—each offering its own set of
challenges and learning opportunities.

My tech journey kicked off in 2016 when I built my first computer.
This experience ignited a profound passion for technology, prompting
me to share my newfound skills with others keen on assembling their
own machines. By 2018, I ventured into Software Engineering, embarking
on a thrilling journey through code and development.

Over time, my interests expanded into the IT realm, leading me to
create a home lab and explore IT hardware extensively. Yet, in 2022, a
pivotal realization dawned upon me: Software Engineering was more than
just an interest; it was my true calling. This epiphany led me to
pursue an Advanced Residency in Software Engineering at Codesmith,
where I delved deep into Backend Engineering and discovered my
professional focus.

A highlight from my time at Codesmith was developing Udemize, a
project where I engineered server-side logic to interact with ChatGPT
based on user inputs—a testament to my passion for creating
intelligent, user-driven solutions.

Beyond the confines of technology, my life is rich with hobbies and
interests. I'm an avid player of Final Fantasy XIV, engaging in
high-end raiding for both the challenge and the camaraderie. Cooking
is another passion of mine, allowing me to explore various cuisines
and flavors. My downtime is spent enjoying the company of my family
and immersing myself in the vibrant worlds of anime.

As I forge ahead in my tech journey, I'm keen on embracing new
challenges, collaborating with fellow enthusiasts, and contributing to
projects that leave a lasting impact.

I invite you to explore my projects, connect with me on LinkedIn,
visit my GitHub, or reach out to me directly. Your interest in my
story is greatly appreciated, and I eagerly anticipate the
opportunities and adventures that the future of technology holds.

Thank you for taking the time to get to know me. Here's to the
exciting journey ahead in the ever-evolving landscape of technology.`,
    terminalFormat: `Paul Walker - Backend Developer
=====================================

Hello! My name is Paul Walker, though you can call me Trey. I'm deeply
engrossed in the world of Backend Engineering, where I've contributed
to compelling projects like Kubby Buddy—each offering its own set of
challenges and learning opportunities.

My tech journey kicked off in 2016 when I built my first computer.
This experience ignited a profound passion for technology, prompting
me to share my newfound skills with others keen on assembling their
own machines. By 2018, I ventured into Software Engineering, embarking
on a thrilling journey through code and development.

Over time, my interests expanded into the IT realm, leading me to
create a home lab and explore IT hardware extensively. Yet, in 2022, a
pivotal realization dawned upon me: Software Engineering was more than
just an interest; it was my true calling. This epiphany led me to
pursue an Advanced Residency in Software Engineering at Codesmith,
where I delved deep into Backend Engineering and discovered my
professional focus.

A highlight from my time at Codesmith was developing Udemize, a
project where I engineered server-side logic to interact with ChatGPT
based on user inputs—a testament to my passion for creating
intelligent, user-driven solutions.

Beyond the confines of technology, my life is rich with hobbies and
interests. I'm an avid player of Final Fantasy XIV, engaging in
high-end raiding for both the challenge and the camaraderie. Cooking
is another passion of mine, allowing me to explore various cuisines
and flavors. My downtime is spent enjoying the company of my family
and immersing myself in the vibrant worlds of anime.

As I forge ahead in my tech journey, I'm keen on embracing new
challenges, collaborating with fellow enthusiasts, and contributing to
projects that leave a lasting impact.

I invite you to explore my projects, connect with me on LinkedIn,
visit my GitHub, or reach out to me directly. Your interest in my
story is greatly appreciated, and I eagerly anticipate the
opportunities and adventures that the future of technology holds.

Thank you for taking the time to get to know me. Here's to the
exciting journey ahead in the ever-evolving landscape of technology.`,
  },

  projects: {
    title: 'Featured Projects',
    content: 'Project content will be added here...',
    terminalFormat: 'Project content will be added here...',
  },

  resume: {
    title: 'Paul Walker - Resume',
    content: 'Resume content will be added here...',
    terminalFormat: 'Resume content will be added here...',
  },

  contact: {
    title: 'Contact Information',
    content: 'Contact content will be added here...',
    terminalFormat: 'Contact content will be added here...',
  },
};

// Navigation URLs for cd command
export const navigationUrls = {
  about: '#about',
  projects: '#projects',
  resume: '#resume',
  contact: '#contact',
};

